/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_SubtitleInputs */

const tr_hakkimizda_subtitle = /** @type {(inputs: Hakkimizda_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkiye'nin çoklu pazaryeri satıcıları için modern, yapay zeka destekli bir yönetim platformu geliştiriyoruz.`)
};

const en_hakkimizda_subtitle = /** @type {(inputs: Hakkimizda_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We are building a modern, AI-powered management platform for Türkiye's multi-marketplace sellers.`)
};

const de_hakkimizda_subtitle = /** @type {(inputs: Hakkimizda_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir entwickeln eine moderne, KI-gestützte Verwaltungsplattform für die Händler mit mehreren Marktplätzen in der Türkei.`)
};

const ru_hakkimizda_subtitle = /** @type {(inputs: Hakkimizda_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мы разрабатываем современную платформу управления с поддержкой искусственного интеллекта для продавцов Турции, работающих на нескольких маркетплейсах.`)
};

/**
* | output |
* | --- |
* | "We are building a modern, AI-powered management platform for Türkiye's multi-marketplace sellers." |
*
* @param {Hakkimizda_SubtitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_subtitle = /** @type {((inputs?: Hakkimizda_SubtitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_SubtitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_subtitle(inputs)
	if (locale === "de") return de_hakkimizda_subtitle(inputs)
	if (locale === "ru") return ru_hakkimizda_subtitle(inputs)
	return tr_hakkimizda_subtitle(inputs)
});